import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Add from "../../Buttons/Add";
import Search from "../../Search/Search";
import Title from "../../Title/Title";

interface ExaminationReportProps {}

const Examination_Report: React.FC<ExaminationReportProps> = () => {
  return (
    <>
      <Row>
        <Col>
          <Title title={"ضبط امتحاني"} />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="رقم الطالب / اسم الطالب / اسم الاب"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td> الرقم الامتحاني </td>
                <td> اسم الطالب </td>
                <td> نسبته</td>
                <td> اسم الاب </td>
                <td> اسم الام </td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>12521</td>
                <td>محمد</td>
                <td> احمد</td>
                <td>احمد</td>
                <td>سعاد</td>
              </tr>
            </tbody>
          </table>
        </Col>
        <Col>
          <Add link="/examination_report/examination" />
        </Col>
      </Row>
    </>
  );
};

export default Examination_Report;
